<!--
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2019-11-15 09:29:32
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2019-11-27 15:32:45
 -->
<template>
  <div class="pi-loading"
       id="pi-loading">
    <img src="./loading.png"
         alt=""
         class="wh100 rotate-loading">
  </div>
</template>

<script>
export default {
  name: 'pi-loading',
  data () {
    return {

    };
  },
  methods: {

  },
  mounted () {

  }
};
</script>

<style lang="less" scoped>
.pi-loading {
  position: fixed;
  width: 0.8rem;
  height: 0.8rem;
  left: 50%;
  top: 50%;
  margin-left: -0.5rem;
  margin-top: -0.5rem;
  z-index: 9;
  padding: 0.15rem;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 0.04rem;
}
.rotate-loading {
  animation: rotateLoading 1s infinite linear;
}
@keyframes rotateLoading {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
